var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 1.55521C6.27606 3.10226 4.04911 3.97099 1.7329 4.00001C1.6449 4.51921 1.6001 5.05521 1.6001 5.60001C1.6001 9.78001 4.2721 13.336 8.0001 14.6536C11.7281 13.336 14.4001 9.78001 14.4001 5.60001C14.4001 5.05441 14.3545 4.52001 14.2673 3.99921C11.9512 3.97041 9.72425 3.10197 8.0001 1.55521ZM8.8001 11.2C8.8001 11.4122 8.71581 11.6157 8.56578 11.7657C8.41575 11.9157 8.21227 12 8.0001 12C7.78792 12 7.58444 11.9157 7.43441 11.7657C7.28438 11.6157 7.2001 11.4122 7.2001 11.2C7.2001 10.9878 7.28438 10.7844 7.43441 10.6343C7.58444 10.4843 7.78792 10.4 8.0001 10.4C8.21227 10.4 8.41575 10.4843 8.56578 10.6343C8.71581 10.7844 8.8001 10.9878 8.8001 11.2ZM8.8001 5.60001C8.8001 5.38783 8.71581 5.18435 8.56578 5.03432C8.41575 4.88429 8.21227 4.80001 8.0001 4.80001C7.78792 4.80001 7.58444 4.88429 7.43441 5.03432C7.28438 5.18435 7.2001 5.38783 7.2001 5.60001V8.00001C7.2001 8.21218 7.28438 8.41566 7.43441 8.56569C7.58444 8.71572 7.78792 8.80001 8.0001 8.80001C8.21227 8.80001 8.41575 8.71572 8.56578 8.56569C8.71581 8.41566 8.8001 8.21218 8.8001 8.00001V5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldExclamation);
export default __webpack_public_path__ + "static/media/ShieldExclamation.99276f8e8d46c7ef8b423d63fb4b3293.svg";
export { ForwardRef as ReactComponent };